@if (item.PlaylistItemLinks[0]?.content; as content) {
  <div class="preview-container" [class.small]="selectedLauncher.isMawChrome"
    (click)="showPreview()">
      <img class="content-img" [src]="content" (load)="isPreviewLoaded = true">

      @if (isVideoFile() && isPreviewLoaded) {
        <div class="play-btn">
          <img src="/assets/img/file-types/video-logo.png">
        </div>
      }
  </div>
}
